import { Outlet, useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/admin-design/_common'
import { LayoutDashboard, Rss, List, Hash, ChartNetwork, Briefcase, KeyRound, Settings } from 'lucide-react'
import { api } from '@/api/client'

const navItems = [
  { to: '/', label: 'Dashboard', end: true, icon: <LayoutDashboard size={14} aria-hidden="true" /> },
  { to: '/sources', label: 'Sources', icon: <Rss size={14} aria-hidden="true" /> },
  { to: '/items', label: 'Items', icon: <List size={14} aria-hidden="true" /> },
  { to: '/topics', label: 'Topics', icon: <Hash size={14} aria-hidden="true" /> },
  { to: '/analysis', label: 'Analysis', icon: <ChartNetwork size={14} aria-hidden="true" /> },
  { to: '/jobs', label: 'Jobs', icon: <Briefcase size={14} aria-hidden="true" /> },
  { to: '/consumers', label: 'Consumers', icon: <KeyRound size={14} aria-hidden="true" /> },
  { to: '/settings', label: 'Settings', icon: <Settings size={14} aria-hidden="true" /> },
]

export default function Layout() {
  const nav = useNavigate()
  const onLogout = async () => {
    try {
      await api.logout()
    } finally {
      nav('/login')
    }
  }
  return (
    <AdminLayout brand="Trend Collector" navItems={navItems} onLogout={onLogout}>
      <Outlet />
    </AdminLayout>
  )
}
